// import React from "react";
// export const Context = React.createContext();

import React, { createContext, useState, useEffect } from "react";

export const Context = createContext();

export const ContextProvider = ({ children }) => {

  const [adminDetails, setAdminDetails] = useState(undefined);

  useEffect(() => {
  
    const storedAdmin = localStorage.getItem("admin_details");
    if (storedAdmin) {
      try {
        setAdminDetails(JSON.parse(storedAdmin));
      } catch (error) {
        console.error("Error parsing admin details:", error);
        setAdminDetails(null);
      }
    } else {
 
      setAdminDetails(null);
    }
  }, []);



  return (
    <Context.Provider value={[adminDetails, setAdminDetails]}>
      {children}
    </Context.Provider>
  );
};
